<script>
import SideNav from '@components/side-nav'
import SideNavClient from '@components/client/side-nav'
import store from '@state/store'

export default {
  components: {
    SideNav,
    SideNavClient,
  },
  data() {
    return {
      // containerWidth: 'width: calc(100% - 280px)',
      primaryContentPosition:
        'left: 280px; top: 0px; width: calc(100% - 280px)',
      toolbarPosition: 'top: -100px',
      toggleMenu: false,
      clientProfile: store.getters['auth/userProfile'],
    }
  },
  mounted() {
    this.calcBodyWidth()
    let that = this
    window.addEventListener('resize', function() {
      that.calcBodyWidth()
    })
  },
  methods: {
    calcBodyWidth() {
      if (window.innerWidth < 980) {
        // this.containerWidth = ''
        this.primaryContentPosition = 'left: 0px; top: 30px; width: 100%'
        this.toolbarPosition = 'top: 0px'
      } else {
        // this.containerWidth = ''
        this.primaryContentPosition =
          'left: 280px; top: 0px; width: calc(100% - 280px)'
        this.toolbarPosition = 'top: -100px'
      }
    },
  },
}
</script>

<template>
  <div :class="$style.primaryContainer">
    <VToolbar
      :style="toolbarPosition"
      dark
      :class="$style.topToolbar"
    >
      <VToolbarSideIcon @click="toggleMenu=!toggleMenu" />
      <VSpacer />
      <img
        src="../../assets/images/power-logo.png"
        alt="power waste logo"
        width="80"
      >
    </VToolbar>

    <div v-if="!clientProfile">
      <SideNav :menu-toggle="toggleMenu" />
    </div>
    <div v-else>
      <SideNavClient :menu-toggle="toggleMenu" />
    </div>

    <div
      :style="primaryContentPosition"
      :class="$style.primaryContent"
    >
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.primaryContainer {
  position: relative;
  width: 100%;
  // max-width: 1500px;
  height: 100%;
  min-height: 100vh;

  .topToolbar {
    position: fixed;
    top: -100px;
  }

  .primaryContent {
    position: relative;
    top: 0;
    left: 280px;
    display: inline-block;
    padding: 20px;
  }
}
</style>
